import { StandardEvents } from '@shopify/events';

const config = document.querySelector('[data-jodhano-cart-config]');
if (config) {
  const { handles, cartUrl, limitMessage, checkingMessage, errorMessage } = JSON.parse(config.textContent);
  const consoles = new Set(handles);
  const pending = new Set();
  const approved = new WeakSet();
  let revision = 0;
  let changedAt = 0;
  let checking = false;
  const changed = () => { revision += 1; changedAt = Date.now(); };
  const show = (message) => {
    document.querySelectorAll('[data-jodhano-cart-status]').forEach((node) => {
      node.textContent = message;
      node.hidden = !message;
    });
  };
  document.addEventListener('quantity-selector:update', (event) => {
    if (event.detail?.cartLine) changed();
  }, true);
  document.addEventListener('input', (event) => {
    if (event.target.closest('cart-items-component')) changed();
  }, true);
  document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
    changed();
    if (!event.promise) return;
    const operation = Promise.resolve(event.promise).catch(() => {}).finally(() => {
      pending.delete(operation);
      changed();
    });
    pending.add(operation);
  }, true);
  const stableCart = async () => {
    const deadline = Date.now() + 12000;
    while (Date.now() < deadline) {
      const cartComponent = customElements.get('cart-items-component');
      const operations = [...pending, ...(cartComponent?.pendingQuantityUpdates || [])];
      if (operations.length || Date.now() - changedAt < 400) {
        await Promise.race([Promise.allSettled(operations), new Promise((resolve) => setTimeout(resolve, 200))]);
        await new Promise((resolve) => setTimeout(resolve, 50));
        continue;
      }
      const before = revision;
      const response = await fetch(cartUrl, { cache: 'no-store', signal: AbortSignal.timeout(6000) });
      if (!response.ok) throw new Error('Cart unavailable');
      const cart = await response.json();
      if (!Array.isArray(cart.items)) throw new Error('Invalid cart');
      if (before !== revision || pending.size) continue;
      return cart;
    }
    throw new Error('Cart still updating');
  };
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || form.id !== 'cart-form') return;
    if (event.submitter?.name !== 'checkout') return;
    if (approved.delete(form)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (checking) return;
    checking = true;
    show(checkingMessage);
    try {
      const cart = await stableCart();
      const count = cart.items.reduce((sum, item) => sum + (consoles.has(item.handle) ? item.quantity : 0), 0);
      if (count > 10) {
        show(limitMessage);
        document.querySelectorAll('button[name="checkout"]').forEach((button) => { button.disabled = true; });
        return;
      }
      const currentForm = document.getElementById('cart-form');
      const button = document.querySelector('button[name="checkout"][form="cart-form"]');
      if (!(currentForm instanceof HTMLFormElement) || !button || !cart.item_count) throw new Error('Cart changed');
      show('');
      approved.add(currentForm);
      button.disabled = false;
      currentForm.requestSubmit(button);
    } catch {
      show(errorMessage);
    } finally {
      checking = false;
    }
  }, true);
}
